import * as React from "react";
import { useSelector } from "react-redux";

function UpdateInstanceIcon({ width = 16, height = 16, ...props }) {
    const { isDarkTheme } = useSelector(({ common }) => common);
    return (
        <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width={width}
                height={height} viewBox="0 0 48 48"><g fill="none"
                    stroke={isDarkTheme ? "#62BAB3" : "#3c4252"} stroke-linecap="round" stroke-linejoin="round" stroke-width="4" {...props}><path d="M44 24L24 4L4 24l20 20l11-11" /><path d="M22 24s12.5-.5 17.5 4.5S39 44 39 44" /><path d="m26 20l-4 4l4 4" /></g></svg>
        </span>
    );
}

export default UpdateInstanceIcon;

